import { TextInput, TextInputProps } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface IProps extends TextInputProps {
  name: string;
}
export default function TextInputControlled({ name, ...props }: IProps) {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextInput
          error={!!error?.message ? t(error.message) : ""}
          {...field}
          {...props}
        />
      )}
    />
  );
}
